export async function fetchData (endpoint, payload) {
  try {
    const response = await this.$http.b2c[endpoint](this, payload)
    return response.data
  } catch (error) {
    console.error('fetchData Request failed:', error)
    throw error
  }
}

export async function fetchHttpData (http, endpoint, payload) {
  try {
    const response = await http.b2c[endpoint](this, payload)
    return response.data
  } catch (error) {
    console.error('fetchHttpData Request failed:', error)
    throw error
  }
}



// WEBPACK FOOTER //
// ./src/config/network/httpService.js